import axios from 'axios'
import { Message } from 'element-ui'
import { getAdminApiBase } from '@/utils/apiBase'
import eventBus from '@/utils/eventBus'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: getAdminApiBase(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

service.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.AuthorizationAdmin = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    const silent = Boolean(response.config && response.config.silent)
    if (typeof res !== 'object' || res === null) {
      if (!silent) Message.error('接口返回数据异常')
      return Promise.reject(new Error('invalid response'))
    }
    if (res.code === 200) {
      return res.data
    }
    if (res.code === 400) {
      if (!silent) Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    if (!silent) Message.error(res.msg || '请求异常')
    return Promise.reject(new Error(res.msg || '请求异常'))
  },
  (error) => {
    const status = error.response?.status
    if (status === 401) {
      eventBus.$emit('auth:unauthorized')
      return Promise.reject(error)
    }
    const msg =
      error.response?.data?.msg ||
      error.message ||
      '网络异常，请稍后重试'
    if (!(error.config && error.config.silent)) Message.error(msg)
    return Promise.reject(error)
  }
)

/**
 * 上传文件（FormData）
 * 复用同一个 axios 实例：AuthorizationAdmin 注入、code===200 解包、错误提示都保持一致。
 * 浏览器环境下 axios 会自动去掉这里手写的 Content-Type，并补上带 boundary 的 multipart 头。
 */
export function uploadFile({ url, file, data = {}, onProgress, timeout = 60000 }) {
  const form = new FormData()
  form.append('file', file)
  Object.keys(data).forEach((key) => {
    const value = data[key]
    if (value !== undefined && value !== null && value !== '') {
      form.append(key, value)
    }
  })

  return service({
    url,
    method: 'post',
    data: form,
    timeout,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (event) => {
      if (typeof onProgress === 'function' && event.total) {
        onProgress(Math.round((event.loaded * 100) / event.total))
      }
    }
  })
}

export default service
